import { render } from "./PatientList.vue?vue&type=template&id=5b90b404&scoped=true"
import script from "./PatientList.vue?vue&type=script&lang=ts"
export * from "./PatientList.vue?vue&type=script&lang=ts"

import "./PatientList.vue?vue&type=style&index=0&id=5b90b404&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5b90b404"

export default script